module.exports = __webpack_public_path__ + "static/media/footer-matcha.0649b662.png";